import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import {
  LeaderboardRankings,
  RexApiContext,
  ContractDateToUse,
  StatisticsForEntityRequestEntityType,
  StatisticsForEntityRequestTimePeriod,
} from '@urbanx/agx.rex.client';

export const useLoadLeaderboardStats = (
  contractDateToUse?: ContractDateToUse,
  fromDate?: string,
  toDateExclusive?: string,
  entityType?: StatisticsForEntityRequestEntityType,
  timePeriod?: StatisticsForEntityRequestTimePeriod,
  selectedAgent?: string
): {
  leaderboardStatsResponse: LeaderboardRankings | undefined;
  isPending: boolean;
  isError: boolean;
} => {
  const rexApi = useContext(RexApiContext);

  const {
    data: leaderboardStatsResponse,
    isPending,
    isError,
  } = useQuery<LeaderboardRankings>({
    queryKey: [
      'GetLeaderboardStatisticsForEntity',
      contractDateToUse,
      fromDate,
      toDateExclusive,
      entityType,
      timePeriod,
      selectedAgent,
    ],
    queryFn: () =>
      rexApi.getLeaderboardStatisticsForEntity({
        contractDateToUse,
        fromDate,
        toDateExclusive,
        entityType,
        timePeriod,
        selectedAgent,
      }),
    enabled: !!fromDate && !!toDateExclusive,
  });

  return { leaderboardStatsResponse, isPending, isError };
};
